import { Destination } from '@rpldy/shared';
import { AxiosResponse } from 'axios';

import * as api from 'utils/api';

export default class FileService {
  /**
   * api request adapter object
   */
  private adapter: api.Adapter;
  /**
   * api domain base URL
   */
  private baseURL: string;

  constructor(baseURL: string) {
    this.adapter = new api.Adapter({
      baseURL,
      responseType: 'json',
      headers: {
        timeout: 60 * 10 * 1000,
        'content-type': 'application/json',
        accept: 'application/json'
      }
    });
    this.baseURL = baseURL;
    // This binding maintains the value of this inside these methods during future calls.
    this.postFile = this.postFile.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
  }

  /**
   * Get destination upload request a file to remote server
   * @param sourceSystem system to associate the file with (e.g: "DWRS")
   *
   * ref: https://github.com/rpldy/react-uploady/blob/master/guides/DifferentConfiguration.md#different-configurations
   */
  postFile(sourceSystem: string): Destination {
    return {
      url: `${this.baseURL}/api/v1/secure-data-storage/document`,
      method: 'POST',
      filesParamName: 'file',
      headers: {
        timeout: 60 * 10 * 1000,
        accept: 'application/json',
        'X-Source-System': sourceSystem
      }
    };
  }

  /**
   * delete a file identifier from the remote server
   * @param identifier file unique identifier
   */
  async deleteFile(identifier: string): Promise<AxiosResponse<unknown>> {
    const url = `/api/v1/secure-data-storage/files/${identifier}`;
    return await this.adapter.deleteValue(url);
  }
}
